import React from 'react';
import {
  Box,
  Card,
  CardContent,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BillingPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1080, mx: 'auto' }}>
        {/* Header */}
        <Skeleton height={isMobile ? 34 : 44} width={isMobile ? 240 : 320} />
        <Skeleton height={isMobile ? 18 : 22} width={isMobile ? '100%' : 520} style={{ marginTop: '4px' }} />

        {/* Status banner */}
        <Box
          sx={{
            p: { xs: 2.5, sm: 3 },
            mt: 3,
            mb: 3,
            borderRadius: '20px',
            background: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Skeleton height={isMobile ? 22 : 26} width={isMobile ? '90%' : 360} />
            <Skeleton height={16} width={isMobile ? '100%' : 300} style={{ marginTop: '4px' }} />
          </Box>
          <Skeleton height={32} width={160} style={{ borderRadius: '16px' }} />
        </Box>

        {/* Amount card */}
        <Card
          sx={{
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
          }}
        >
          <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
            {/* Stepper */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: { xs: 4, sm: 8 }, mb: 4 }}>
              {[0, 1].map((i) => (
                <Box key={i} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                  <Skeleton circle width={24} height={24} />
                  <Skeleton height={14} width={isMobile ? 70 : 100} />
                </Box>
              ))}
            </Box>

            {/* Review amount block */}
            <Box sx={{ maxWidth: 460, mx: 'auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Skeleton width={48} height={48} style={{ borderRadius: '12px' }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton height={24} width={isMobile ? '90%' : 220} />
                  <Skeleton height={16} width={isMobile ? '100%' : 280} />
                </Box>
              </Box>

              {/* Breakdown */}
              <Box sx={{ p: 2, borderRadius: '16px', background: '#f7f7f7' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Skeleton height={16} width={110} />
                  <Skeleton height={16} width={70} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Skeleton height={16} width={150} />
                  <Skeleton height={16} width={60} />
                </Box>
                <Skeleton height={1} width="100%" style={{ margin: '12px 0' }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <Skeleton height={18} width={90} />
                  <Skeleton height={30} width={120} />
                </Box>
              </Box>

              <Skeleton height={16} width={isMobile ? '100%' : 360} style={{ marginTop: '12px' }} />

              <Skeleton height={48} style={{ borderRadius: '12px', marginTop: '24px' }} />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </SkeletonTheme>
  );
};

export default BillingPageSkeleton;
